import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { 
  Home, ArrowUpCircle, ArrowDownCircle, Send, History, User, Settings, 
  Shield, LogOut, Bell, ChevronRight, CheckCircle, TrendingUp, Newspaper,
  CreditCard, Gift, Star, Zap
} from "lucide-react";

// Browser Frame Component with theme support
const BrowserFrame = ({ theme = 'light' }) => {
  const isLight = theme === 'light';
  const bgColor = isLight ? '#dee1e6' : '#202124';
  const tabBgInactive = isLight ? '#f1f3f4' : '#35363a';
  const tabBgActive = isLight ? '#fff' : '#292a2d';
  const textColor = isLight ? '#5f6368' : '#9aa0a6';
  const textColorActive = isLight ? '#202124' : '#e8eaed';
  const addressBarBg = isLight ? '#f1f3f4' : '#35363a';
  
  return (
    <div className="flex-shrink-0" style={{ backgroundColor: bgColor }}>
      <div className="flex items-center h-[38px]" style={{ backgroundColor: bgColor }}>
        <div className="flex items-end flex-1 pl-2">
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px] cursor-pointer" style={{ backgroundColor: tabBgInactive }}>
            <img src="https://finance.ozon.ru/favicon.ico" alt="" className="w-4 h-4 mr-2 flex-shrink-0" />
            <span className="text-[13px] truncate flex-1" style={{ color: textColor }}>Ozon Карта</span>
          </div>
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px] cursor-pointer" style={{ backgroundColor: tabBgActive }}>
            <img src="https://customer-assets.emergentagent.com/job_task-master-543/artifacts/g6wnx4m7_image.png" alt="" className="w-4 h-4 mr-2 flex-shrink-0" />
            <span className="text-[13px] truncate flex-1" style={{ color: textColorActive }}>ONESIX Wallet</span>
          </div>
          <button className="w-7 h-7 flex items-center justify-center rounded-full ml-1 mb-1" style={{ color: textColor }}>
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
          </button>
        </div>
        <div className="flex items-center h-full">
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#c8cace]" style={{ color: textColor }}><svg className="w-[10px] h-[1px]" viewBox="0 0 10 1"><rect fill="currentColor" width="10" height="1"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#c8cace]" style={{ color: textColor }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1"><rect x="0.5" y="0.5" width="9" height="9"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#e81123] hover:text-white" style={{ color: textColor }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" stroke="currentColor" strokeWidth="1.2"><line x1="0" y1="0" x2="10" y2="10"/><line x1="10" y1="0" x2="0" y2="10"/></svg></button>
        </div>
      </div>
      <div className="flex items-center h-[40px] px-2" style={{ backgroundColor: tabBgActive }}>
        <div className="flex items-center gap-1 mr-2">
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: isLight ? '#dadce0' : '#5f6368' }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg></button>
        </div>
        <div className="flex-1 flex items-center h-[32px] px-4 rounded-full" style={{ backgroundColor: addressBarBg }}>
          <svg className="w-4 h-4 mr-3 flex-shrink-0" style={{ color: textColor }} viewBox="0 0 24 24" fill="currentColor"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
          <span className="text-[14px]" style={{ color: textColorActive }}>onesix.io/wallet</span>
        </div>
        <div className="flex items-center gap-1 ml-3">
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg></button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/><circle cx="12" cy="19" r="2"/></svg></button>
        </div>
      </div>
    </div>
  );
};

// Crypto icons
const CryptoIcon = ({ symbol }) => {
  const icons = {
    USDT: { bg: 'linear-gradient(135deg, #26A17B, #1a7d5f)', text: '₮' },
    BTC: { bg: 'linear-gradient(135deg, #F7931A, #c77615)', text: '₿' },
    ETH: { bg: 'linear-gradient(135deg, #627EEA, #4a62b8)', text: 'Ξ' },
    USDC: { bg: 'linear-gradient(135deg, #2775CA, #1d5a9e)', text: '$' },
    BNB: { bg: 'linear-gradient(135deg, #F3BA2F, #c49625)', text: 'B' },
    TRX: { bg: 'linear-gradient(135deg, #FF0013, #cc000f)', text: 'T' },
    SOL: { bg: 'linear-gradient(135deg, #9945FF, #14F195)', text: 'S' },
  };
  const icon = icons[symbol] || { bg: 'linear-gradient(135deg, #666, #444)', text: '?' };
  return (
    <div 
      className="w-10 h-10 rounded-xl flex items-center justify-center text-white font-bold text-lg shadow-lg"
      style={{ background: icon.bg }}
    >
      {icon.text}
    </div>
  );
};

export default function NovapayMain() {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [balances, setBalances] = useState({});
  const [activeTab, setActiveTab] = useState('main');
  const [showBrowser, setShowBrowser] = useState(true);
  const [browserTheme, setBrowserTheme] = useState('light');

  useEffect(() => {
    const dataParam = searchParams.get('data');
    const browserParam = searchParams.get('showBrowser');
    const themeParam = searchParams.get('theme');
    
    if (browserParam !== null) {
      setShowBrowser(browserParam !== 'false');
    }
    if (themeParam) {
      setBrowserTheme(themeParam);
    }
    
    if (dataParam) {
      try {
        const parsed = JSON.parse(decodeURIComponent(dataParam));
        setData(parsed);
        if (parsed.showBrowser !== undefined) {
          setShowBrowser(parsed.showBrowser);
        }
        if (parsed.browserTheme) {
          setBrowserTheme(parsed.browserTheme);
        }
        // Generate random balances
        setBalances({
          USDT: (Math.random() * 500).toFixed(2),
          BTC: (Math.random() * 0.015).toFixed(6),
          ETH: (Math.random() * 0.3).toFixed(5),
          USDC: (Math.random() * 400).toFixed(2),
          BNB: (Math.random() * 1.5).toFixed(4),
          TRX: (Math.random() * 800).toFixed(2),
          SOL: (Math.random() * 5).toFixed(3),
        });
      } catch (e) {
        console.error("Error parsing data:", e);
      }
    }
    
    // Set body background to fix zoom issue
    document.body.style.backgroundColor = '#f8fafc';
    document.documentElement.style.backgroundColor = '#f8fafc';
    
    return () => {
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
    };
  }, [searchParams]);

  if (!data) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-violet-600 via-blue-600 to-indigo-700 flex items-center justify-center">
        <div className="text-white text-lg">Загрузка...</div>
      </div>
    );
  }

  const accountName = `${data.firstName || ''} ${data.lastName || ''}`.trim() || 'Пользователь';
  const userId = data.novapayId || Math.floor(100000 + Math.random() * 900000);

  const menuItems = [
    { icon: Home, label: 'Главная', id: 'main', active: true },
    { icon: ArrowUpCircle, label: 'Пополнить', id: 'deposit' },
    { icon: ArrowDownCircle, label: 'Вывести', id: 'withdraw' },
    { icon: Send, label: 'Перевод', id: 'transfer' },
    { icon: History, label: 'История', id: 'history' },
    { icon: CreditCard, label: 'Карты', id: 'cards' },
    { icon: User, label: 'Профиль', id: 'profile' },
    { icon: Shield, label: 'Безопасность', id: 'security' },
    { icon: Settings, label: 'Настройки', id: 'settings' },
  ];

  const cryptoList = [
    { symbol: 'USDT', name: 'Tether USD', rate: '≈ $1.00' },
    { symbol: 'BTC', name: 'Bitcoin', rate: '≈ $97,500' },
    { symbol: 'ETH', name: 'Ethereum', rate: '≈ $3,450' },
    { symbol: 'USDC', name: 'USD Coin', rate: '≈ $1.00' },
    { symbol: 'BNB', name: 'Binance Coin', rate: '≈ $680' },
    { symbol: 'TRX', name: 'TRON', rate: '≈ $0.25' },
    { symbol: 'SOL', name: 'Solana', rate: '≈ $180' },
  ];

  const news = [
    { 
      icon: Gift, 
      title: 'Бонус за верификацию', 
      text: 'Пройдите верификацию и получите 10 USDT на баланс',
      color: 'from-green-500 to-emerald-600'
    },
    { 
      icon: TrendingUp, 
      title: 'Новые торговые пары', 
      text: 'Добавлены пары SOL/USDT и AVAX/USDT',
      color: 'from-blue-500 to-cyan-600'
    },
    { 
      icon: Zap, 
      title: 'Мгновенные переводы', 
      text: 'Переводы между пользователями теперь без комиссии',
      color: 'from-yellow-500 to-orange-600'
    },
  ];

  const totalUSD = Object.entries(balances).reduce((acc, [symbol, amount]) => {
    const rates = { USDT: 1, BTC: 97500, ETH: 3450, USDC: 1, BNB: 680, TRX: 0.25, SOL: 180 };
    return acc + (parseFloat(amount) * (rates[symbol] || 0));
  }, 0);

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#f8fafc', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      {showBrowser && <BrowserFrame theme={browserTheme} />}
      <div className="flex-1 flex bg-slate-50">
      {/* Sidebar */}
      <aside className="w-64 bg-gradient-to-b from-violet-600 via-blue-600 to-indigo-700 flex flex-col shadow-2xl">
        {/* Logo */}
        <div className="p-5 border-b border-white/10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 backdrop-blur rounded-xl flex items-center justify-center overflow-hidden">
              <img src="https://customer-assets.emergentagent.com/job_task-master-543/artifacts/g6wnx4m7_image.png" alt="ONESIX" className="w-8 h-8 object-contain" />
            </div>
            <div>
              <h1 className="text-white font-bold text-xl tracking-tight">ONESIX</h1>
              <p className="text-blue-200 text-xs">Crypto Wallet</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-4 overflow-y-auto">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id)}
                className={`w-full flex items-center gap-3 px-5 py-3 text-sm transition-all ${
                  item.active 
                    ? 'bg-white/20 text-white border-r-4 border-white' 
                    : 'text-blue-100 hover:bg-white/10 hover:text-white'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="p-4 border-t border-white/10">
          <button className="w-full flex items-center gap-3 px-4 py-2.5 text-blue-200 hover:text-white hover:bg-white/10 rounded-lg transition-colors">
            <LogOut className="w-5 h-5" />
            <span>Выйти</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <header className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between shadow-sm">
          <div>
            <h2 className="text-xl font-bold text-slate-800">Добро пожаловать!</h2>
            <p className="text-slate-500 text-sm">Управляйте своими активами</p>
          </div>
          
          <div className="flex items-center gap-4">
            {/* Verified Badge */}
            <div className="flex items-center gap-2 px-3 py-1.5 bg-green-50 border border-green-200 rounded-full">
              <CheckCircle className="w-4 h-4 text-green-600" />
              <span className="text-green-700 text-sm font-medium">Верифицирован</span>
            </div>
            
            {/* Notification */}
            <button className="p-2 text-slate-500 hover:text-slate-700 relative">
              <Bell className="w-5 h-5" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
            </button>
            
            {/* User */}
            <div className="flex items-center gap-3 pl-4 border-l border-slate-200">
              <div className="w-9 h-9 bg-gradient-to-br from-violet-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white text-sm font-bold">
                  {accountName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)}
                </span>
              </div>
              <div>
                <p className="text-sm font-medium text-slate-800">{accountName}</p>
                <p className="text-xs text-slate-500">ID: {userId}</p>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-6 overflow-auto bg-slate-50">
          {/* Total Balance Card */}
          <div className="bg-gradient-to-r from-violet-600 via-blue-600 to-indigo-600 rounded-2xl p-6 text-white mb-6 shadow-xl">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-blue-100 text-sm mb-1">Общий баланс</p>
                <h3 className="text-4xl font-bold tracking-tight">{(data.balance || 0).toLocaleString('ru-RU')} ₽</h3>
                <p className="text-blue-200 text-sm mt-2 flex items-center gap-1">
                  <TrendingUp className="w-4 h-4" />
                  +2.4% за последние 24ч
                </p>
              </div>
              <div className="flex gap-3">
                <button className="px-5 py-2.5 bg-white/20 backdrop-blur hover:bg-white/30 rounded-xl font-medium transition-colors flex items-center gap-2">
                  <ArrowUpCircle className="w-4 h-4" />
                  Пополнить
                </button>
                <button className="px-5 py-2.5 bg-white text-violet-600 hover:bg-blue-50 rounded-xl font-medium transition-colors flex items-center gap-2">
                  <Send className="w-4 h-4" />
                  Отправить
                </button>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-6">
            {/* Crypto Assets */}
            <div className="col-span-2 bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
              <div className="p-5 border-b border-slate-100 flex items-center justify-between">
                <h3 className="font-semibold text-slate-800 text-lg">Мои активы</h3>
                <button className="text-violet-600 text-sm font-medium hover:text-violet-700 flex items-center gap-1">
                  Все активы <ChevronRight className="w-4 h-4" />
                </button>
              </div>
              <div className="divide-y divide-slate-50">
                {cryptoList.map((crypto) => (
                  <div key={crypto.symbol} className="p-4 flex items-center justify-between hover:bg-slate-50 transition-colors">
                    <div className="flex items-center gap-4">
                      <CryptoIcon symbol={crypto.symbol} />
                      <div>
                        <p className="font-semibold text-slate-800">{crypto.symbol}</p>
                        <p className="text-slate-500 text-sm">{crypto.name}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="font-semibold text-slate-800">{balances[crypto.symbol] || '0.00'}</p>
                      <p className="text-slate-500 text-sm">{crypto.rate}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* News & Info */}
            <div className="space-y-4">
              {/* Account Status */}
              <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center">
                    <Shield className="w-5 h-5 text-green-600" />
                  </div>
                  <div>
                    <p className="font-semibold text-slate-800">Статус аккаунта</p>
                    <p className="text-green-600 text-sm font-medium">Полностью верифицирован</p>
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-slate-500">ID аккаунта</span>
                    <span className="font-medium text-slate-800">{userId}</span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-slate-500">Уровень</span>
                    <span className="font-medium text-violet-600">PRO</span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-slate-500">Лимит вывода</span>
                    <span className="font-medium text-slate-800">$50,000/день</span>
                  </div>
                </div>
              </div>

              {/* News */}
              <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
                <div className="flex items-center gap-2 mb-4">
                  <Newspaper className="w-5 h-5 text-slate-400" />
                  <h3 className="font-semibold text-slate-800">Новости</h3>
                </div>
                <div className="space-y-3">
                  {news.map((item, index) => {
                    const Icon = item.icon;
                    return (
                      <div key={index} className="p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition-colors cursor-pointer">
                        <div className="flex items-start gap-3">
                          <div className={`w-8 h-8 bg-gradient-to-br ${item.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                            <Icon className="w-4 h-4 text-white" />
                          </div>
                          <div>
                            <p className="font-medium text-slate-800 text-sm">{item.title}</p>
                            <p className="text-slate-500 text-xs mt-0.5">{item.text}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      </div>
    </div>
  );
}
